
module.exports = function PinInput ($host, config) {

  // Config
  var okClass      = 'ok';
  var errorClass   = 'error';
  var busyClass    = 'is-busy';
  var acceptClass  = 'is-accepted';
  var animateClass = 'animation-shake';
  var pendingText  = 'Enter PIN to proceed';
  var acceptText   = 'PIN accepted';
  var errorText    = 'Incorrect PIN';

  // DOM
  var $digits = $('[data-pin-dots] span', $host);
  var $text   = $('[data-help-text]', $host);

  // State
  var state = { digits: [], lock: false, clearTimer: 0 };

  // Callbacks
  var callbacks = { pin: id };

  // Functions
  function checkPinLength (digits) {
    if (digits.length >= 4) {
      callbacks.pin(digits.join(''));
    }
  }

  function lock (mode) {
    state.lock = mode;
  }

  function update (digits) {
    $digits.each(function (ix, el) {
      $(this).removeClass(errorClass).toggleClass(okClass, digits.length > ix);
    });
  }

  function setBusy (mode) {
    $host.toggleClass(busyClass, mode);
    lock(mode);
  }

  function showAccept () {
    $host.addClass(acceptClass);
    $text.text(acceptText);
  }

  function showReject () {
    $digits.addClass(errorClass).removeClass(okClass);
    $host.addClass(animateClass).removeClass(busyClass);
    $text.text(errorText);
    state.clearTimer = delay(2, clearError);
  }

  function clearError () {
    $digits.removeClass(errorClass);
    $host.removeClass(animateClass);
    $text.text(pendingText);
    clearTimeout(state.clearTimer);
    lock(false);
  }

  function injectChar (ch) {
    if (state.lock) {
      clearError();
      clear();
    }

    state.digits.push(ch);
    update(state.digits);
    checkPinLength(state.digits);
  }

  function clear () {
    setBusy(false);
    state.digits = [];
    update(state.digits);
  }

  // Public interface
  return {
    busy:   setBusy,
    clear:  clear,
    inject: injectChar,
    onPin:  function (λ) { callbacks.pin = λ; },
    accept: function () { clear(); showAccept(); },
    reject: function () { clear(); showReject(); },
  };
}

